import React, { useEffect, useState } from "react";
import { Button, Box } from "common";
import { Checkbox, MenuItem } from "@material-ui/core";
import { useDispatch, useSelector } from "react-redux";
import { setPromotionObject } from "store/actions/promotion.actions";
import { setSelectedShipments } from "store/actions/shipmentServices.actions";
import { ISelectedShipments } from "store/reducers/shipmentServices.reducers";
import { IState } from "store/store.interface";
import { useStyles } from "../Restrictions.style";

const ShipmentItems = ({
  options,
  isMenuOpen,
  menuOpenHandler,
  name,
}: {
  options: ISelectedShipments[];
  isMenuOpen: boolean;
  menuOpenHandler: any;
  name: string
}) => {
  const { dropdownBox } = useStyles();

  const { creationForm,selectedShipments =[] } = useSelector((state: IState) => ({
      ...state.promotion,
      ...state.shipmentServices
    }));

   const [selected, setSelected] = useState<ISelectedShipments[]>(selectedShipments);
  const dispatch = useDispatch();

  const isSelected = (item: ISelectedShipments) =>
    selected.some((s) => s.value === item.value);

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>, item: ISelectedShipments) => {
    const alreadySelected = selected.find((s) => s.label === item.label);

    if (alreadySelected) {
      setSelected((prev) => prev.filter((s) => s.label !== item.label));
    } else {
      setSelected((prev) => [...prev, item]);
    }
  };
  const clearState = () => {
    setSelected([]);
    dispatch(setSelectedShipments([]));
    dispatch(setPromotionObject("", ["restrictions", name]));
  };
  const applyFilters = () => {
    menuOpenHandler(!isMenuOpen);
    dispatch(setSelectedShipments(selected));
  };

// This is used check the checkboxes when editing campaign which is having shipmentRules  
   useEffect(() => {
    if(creationForm?.edit && selectedShipments?.length > 0){
      setSelected(selectedShipments)
    }
  }, [creationForm.edit,selectedShipments])
  
  return (
    <Box
      display={isMenuOpen ? "" : "none"}
      className={dropdownBox}
    >
      {options.map((item) => {
        return (
          <MenuItem key={item.label}>
            <Checkbox
              data-testid={`shipment-multi-checkbox-${item.value}`}
              checked={isSelected(item)}
              onChange={(e) => handleChange(e, item)}
              name={item.label}
              color="primary"
            />
            {item.label}
          </MenuItem>
        );
      })}
      <Box display={"flex"} alignItems="center" justifyContent={"flex-end"}>
        <Button
          round
          variant="outlined"
          color="primary"
          margin="10px"
          onClick={clearState}
        >
          Clear
        </Button>
        <Button
          round
          variant="contained"
          color="secondary"
          margin="10px"
          onClick={applyFilters}
        >
          Apply
        </Button>
      </Box>
    </Box>
  );
};

export default ShipmentItems;
